<template>
  <listing-layout>
    <h1 slot="heading" class="h2 mb-3">Judges Applications</h1>
    <div slot="content">
      <div class="alert alert-warning" v-if="error">{{error}}</div>
      <div role="alert" class="alert alert-success mt-3" v-if="success">{{success}}</div>
      <listAppsTable />
    </div>
  </listing-layout>
</template>

<script>
/* Use the "slot" attribute to match the heading and content
 * to their respective fields in the ListingLayout component. */

import listingLayout from '@/components/ListingLayout'
import dataTable from '@/components/DataTable'
import tableTextTemplate from '@/components/DataTableFields/Text'
import tablePdfIconTemplate from '@/components/DataTableFields/PdfIcon'
import listAppsTable from './components/ListAppsTable'

export default {
  name: 'AdminJudgeAppsList',
  components: {
    'listing-layout': listingLayout,
    'data-table': dataTable,
    tableTextTemplate,
    tablePdfIconTemplate,
    listAppsTable
  },
  data() {
    return {
      error: '',
      success: localStorage.getItem("judge-app-status")
    }
  },
  mounted() {
    localStorage.removeItem("judge-app-status")
  }
}
</script>



// WEBPACK FOOTER //
// src/views/Judges/Application/AdminJudgeAppsList.vue